import { Component, OnInit } from '@angular/core';

import { trigger, style, animate, transition, state } from '@angular/animations';
import { Agent, Office } from '../../../shared/models/missingdata.model';
import { OfficeService } from '../../../shared/_services/office.service';
import { CityService } from '../../../shared/_services/city.service';
import { AgentService } from '../../../shared/_services/agent.service';

@Component({
  selector: 'app-table-agents',
  templateUrl: './table-agents.component.html',
  styleUrls: ['../admin-tables.component.css'],
  animations: [
    trigger('EnterLeave', [
      state('flyin', style({
        opacity: 1,
        transform: 'translateX(0%)'
      })),
      transition(':enter', [
        style({
          opacity: 0.2,
          transform: 'translateX(-100%)',
        }),
        animate('0.3s 300ms ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          transform: 'translateX(100%)'
        }))
      ])
    ])
  ]

})
export class TableAgentsComponent implements OnInit {


  SearchTerm: string;
  List: Agent[];
  List2: Office[];
  NewElement: Agent;
  saveElement: Agent[] = [];
  FormNew = false;
  error: string;
  message: string;

  p: number = 1;
  idSelected: number = -1;

  constructor(
    private officeService: OfficeService,
    private agentService: AgentService
  ) { }

  ngOnInit() {
    this.officeService.getOffices()
      .subscribe((res: Office[]) => {
        this.List2 = res;
        this.agentService.getAgents()
          .subscribe((lista: Agent[]) => {
            this.List = lista;
            console.log(this.List);
          }, err => console.log(err))
      }, err => console.log(err))
  }

  cleanMessage() {
    this.message = undefined;
    this.error = undefined;
    this.saveElement = [];
  }

  onKeyUp(value) {
    this.SearchTerm = value;
  }

  toggleNew() {
    this.NewElement = new Agent;
    this.FormNew = !this.FormNew;
  }

  add() {
    this.cleanMessage();
    if (this.NewElement) {
      this.NewElement.fkIdOffice = this.idSelected;
      this.saveElement.push(this.NewElement);
      this.agentService.saveAgents(this.saveElement)
        .subscribe(res => {
          this.List.push(this.NewElement);
          this.List.sort((a, b) => a.idAgentKey < b.idAgentKey ? -1 : a.idAgentKey > b.idAgentKey ? 1 : 0);
          this.FormNew = false;
          this.message = "Elemento agregado correctamente";
          setTimeout(() => {
            this.cleanMessage();
          }, 5000);
        }, err => this.error = err
        )
    }
  }

  changeValue(idAgentKey: any) {
    this.cleanMessage();
    let name = "[date-agent ='" + idAgentKey + "']";
    document.querySelectorAll(name).forEach(function (element) {
      element.removeAttribute("readonly");
    })
    document.getElementsByName("btgrnoffice-" + idAgentKey)[0].removeAttribute("hidden");

    document.getElementsByName("btednoffice-" + idAgentKey)[0].setAttribute("hidden", "hidden");
  }

  updateList(idAgentKey: any) {
    this.cleanMessage();
    let name = "[date-agent = '" + idAgentKey + "']";
    document.querySelectorAll(name).forEach(function (element) {
      element.setAttribute("readonly", "readonly");
    });

    //console.log(this.List.find(t => t.idOffice == idOffice));

    this.agentService.updateAgent(this.List.find(t => t.idAgentKey == idAgentKey))
      .subscribe(res => {
        document.getElementsByName("btednoffice-" + idAgentKey)[0].removeAttribute("hidden");
        document.getElementsByName("btgrnoffice-" + idAgentKey)[0].setAttribute("hidden", "hidden");
      }, err => this.error = err)

  }

  officeName(fkIdOffice: number) {
    return this.List2.find(u => u.idOffice == fkIdOffice).officeName;
  }

  pageChange($event) {
    this.p = $event;
    document.getElementById('table-body').scrollTop = 0;
  }


}
